
import { builderDispatch } from '../_utils/ui';
import GroupedCategoryChangeEvents from './grouped-category-change-events';
import Currency from '../_utils/tools/currency';

builderDispatch.register((payload) => {
  if (typeof dataLayer !== 'object') return;

  switch (payload.type) {
    case GroupedCategoryChangeEvents.PRODUCT_SELECTED:
      handleProductSelected(payload.product);
      break;
  }
});

function handleProductSelected(product) {
  dataLayer.push({
    event: 'itemSelected',
    product: {
      catalog_item_id: product.partner_id,
      sku: product.code,
      price: Currency.format(product.minimum_price),
      filters: product.filters,
    },
  });
}
